export { createInternalGTMTracker, pushInternalGTMDataLayer, DATA_LAYER_KEY } from './internal-gtm-tracker';
